import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function deleteConfigurationProfiles(profileId: number) {
  return fromFetch(
    new Request(`${fleetEnvironment.configurationProfilesUrl}/${profileId}`, {
      method: 'DELETE',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(ignoreData());
}
